import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import LoginForm from "@/components/LoginForm.vue";
import AppBar from "@/components/AppBar.vue";
import { Mutation } from "vuex-class";
let Login = class Login extends Vue {
    setShowDrawer;
    mounted() {
        this.setShowDrawer(false);
    }
};
__decorate([
    Mutation
], Login.prototype, "setShowDrawer", void 0);
Login = __decorate([
    Component({
        components: {
            LoginForm,
            AppBar
        },
    })
], Login);
export default Login;
